{
  "clear": "Effacer",
  "invalid": "(non valide)",
  "loading": "Chargement en cours…",
  "noResults": "Aucun résultat"
}
